import React from 'react'
import { IntlContextConsumer, changeLocale } from 'gatsby-plugin-intl'

const languageName = {
  es: 'Español',
  en: 'English'
}

const Language = () => {
  return (
    <div>
      <IntlContextConsumer>
        {({ languages, language }) => (
          <select value={language} onChange={e => changeLocale(e.target.value)}>
            {languages.map(lang => (
              <option key={lang} value={lang}>
                {languageName[lang]}
              </option>
            ))}
          </select>
        )}
      </IntlContextConsumer>
    </div>
  )
}

export default Language
